import React from "react";
import { Copy, KeyRound, AlertTriangle, ExternalLink } from "lucide-react";
import { toast } from "sonner";
import { Button } from "./ui/button";
import {
  Dialog, DialogContent, DialogDescription, DialogFooter, DialogHeader, DialogTitle,
} from "./ui/dialog";

export default function AgentKeyRevealCard({ data, onClose, onView }) {
  const secret = data?.api_key?.secret;
  const agentId = data?.agent?.id;
  const did = data?.agent?.did;
  const copy = (txt, label) => {
    navigator.clipboard.writeText(txt);
    toast.success(`${label} copied`);
  };
  return (
    <Dialog open={Boolean(data)} onOpenChange={(o) => !o && onClose?.()}>
      <DialogContent data-testid="agent-key-reveal" className="rounded-sm">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2 font-medium">
            <KeyRound className="w-4 h-4 text-amber-600 dark:text-amber-400" strokeWidth={1.5} />
            Save this key — shown ONCE
          </DialogTitle>
          <DialogDescription>
            We hash keys at rest. If you lose this secret you'll need to mint a fresh
            one. Hand it to your agent runtime over a secure channel.
          </DialogDescription>
        </DialogHeader>
        <div className="space-y-3 py-2">
          <div className="border border-amber-500/40 bg-amber-500/10 rounded-sm p-3 text-xs text-amber-700 dark:text-amber-300 flex gap-2">
            <AlertTriangle className="w-4 h-4 mt-0.5 shrink-0" strokeWidth={1.5} />
            <div>
              This is the only time you'll see this secret. After this dialog closes
              the key is no longer recoverable.
            </div>
          </div>
          <div>
            <div className="text-[10px] uppercase tracking-[0.2em] text-muted-foreground mb-1">Agent DID</div>
            <button
              data-testid="reveal-did"
              onClick={() => copy(did, "DID")}
              className="w-full text-left px-3 py-2 border border-border rounded-sm bg-muted font-mono text-xs flex items-center justify-between gap-2 hover:border-foreground"
            >
              <span className="truncate">{did}</span>
              <Copy className="w-3 h-3 shrink-0" strokeWidth={1.5} />
            </button>
          </div>
          <div>
            <div className="text-[10px] uppercase tracking-[0.2em] text-muted-foreground mb-1">API key</div>
            <button
              data-testid="reveal-secret"
              onClick={() => copy(secret, "API key")}
              className="w-full text-left px-3 py-2 border border-foreground rounded-sm bg-foreground/5 font-mono text-xs break-all flex items-center justify-between gap-2"
            >
              <span className="break-all">{secret}</span>
              <Copy className="w-3 h-3 shrink-0" strokeWidth={1.5} />
            </button>
          </div>
        </div>
        <DialogFooter>
          <Button variant="outline" onClick={onClose} className="rounded-sm">Close</Button>
          <Button onClick={onView} data-testid="reveal-open-agent" className="rounded-sm">
            <ExternalLink className="w-3 h-3 mr-1.5" strokeWidth={1.5} /> Open agent
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
